import React from 'react';
import { TextInput, TextArea, StringList, SectionHeader } from './Fields';
import ImageUpload from './ImageUpload';

const TransformacaoEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Transformação" />
      <TextInput label="Badge" value={data.badge} onChange={v => set('badge', v)} />
      <TextArea label="Título" value={data.heading} onChange={v => set('heading', v)} rows={2} />
      <TextInput label="Parte destacada do título (azul)" value={data.heading_highlight} onChange={v => set('heading_highlight', v)} hint="Deve ser parte exata do título" />
      <TextArea label="Texto introdutório" value={data.body} onChange={v => set('body', v)} rows={3} />
      <StringList
        label="Lista de funcionalidades"
        value={data.features}
        onChange={v => set('features', v)}
        placeholder="Ex: Automatizar processos burocráticos."
      />
      <ImageUpload label="Imagem" value={data.image_url} onChange={v => set('image_url', v)} />
    </div>
  );
};

export default TransformacaoEditor;
